import { useState } from 'react'
import { Facet, OptionFacetValue } from './Types'
import { Checkbox, CheckboxGroup } from 'components/forms'
import { InlineCounter } from '../../../product-filters/components/sections/filter-section'
// @ts-ignore
import pluralize from 'pluralize'

interface MultiSelectFacetProps {
  facet: Facet<OptionFacetValue>
  onChange: (selectedOptions: string[]) => void
  initialValues: string[]
}

export const MultiSelectFacet = ({
  facet,
  onChange,
  initialValues = [],
}: MultiSelectFacetProps) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    Array.isArray(initialValues) ? initialValues : [initialValues]
  )
  const [viewAllChecked, setViewAllChecked] = useState<boolean>(
    initialValues.length === 0
  )

  const handleChange = (option: string, checked: boolean) => {
    if (viewAllChecked) setViewAllChecked(false)
    let updatedOptions: string[]
    if (checked) {
      updatedOptions = [...selectedOptions, option]
    } else {
      updatedOptions = selectedOptions.filter(
        (selectedOption) => selectedOption !== option
      )
    }
    setSelectedOptions(updatedOptions)
    onChange(updatedOptions)
  }

  const handleViewAllChange = (checked: boolean) => {
    if (checked) {
      setSelectedOptions([])
      onChange([])
    }
    setViewAllChecked(checked)
  }
  return (
    // @ts-ignore
    <CheckboxGroup>
      <Checkbox
        checked={viewAllChecked}
        label={`View All ${pluralize(facet.label, 2)}`}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleViewAllChange(e.target.checked)
        }
        size="large"
      />
      {Array.isArray(facet.values) &&
        facet.values.map(
          ({ label, count }: { label: string; count: number }) => {
            const labelComponent = (
              <span>
                {label}
                <InlineCounter count={count} />
              </span>
            )
            const isChecked = selectedOptions.includes(label)
            return (
              <Checkbox
                checked={isChecked}
                key={label}
                label={labelComponent}
                value={label}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(label, e.target.checked)
                }
                size="large"
              />
            )
          }
        )}
    </CheckboxGroup>
  )
}
